// https://stackoverflow.com/a/40975730/10688891
function daysSinceNewYear(date: Date) {
  return (
    (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) -
      Date.UTC(date.getFullYear(), 0, 0)) /
    24 /
    60 /
    60 /
    1000
  )
}

const randomNumberForToday = (
  lowerBound: number,
  upperBound: number,
  date: Date = new Date()
) => {
  const range = upperBound - lowerBound
  const randomOffset = daysSinceNewYear(date) % range
  return lowerBound + randomOffset
}

export default randomNumberForToday
